var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:({ cursor: 'pointer' }),attrs:{"width":_vm.schema.width,"height":_vm.schema.height,"src":_vm.value},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }